export default __webpack_public_path__ + "static/media/rieltor-2.825216a1.png";